module.exports = "/assets/data/49042755ec8c7cb8d47c7eea428acb10-DE4.data.json";